export var setCookie = function setCookie(name, value, cookieDomain) {
  if (typeof window === 'undefined') {
    throw Error('Error: setCookie is not available outside the browser');
  }
  var date = new Date();
  date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
  document.cookie = "".concat(name, "=").concat(value || '', ";  ").concat(cookieDomain, "expires=").concat(date.toUTCString(), "; path=/");
};
export var getCookie = function getCookie(name) {
  if (typeof window === 'undefined') {
    throw Error('Error: getCookie is not available outside the browser');
  }
  var nameEQ = "".concat(name, "=");
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};